import useTranslation from 'next-translate/useTranslation';

// Hooks
import { UPDATE_ALBUM_NAME, useAlbumContext } from '@/utils/hooks/context/useAlbumContext';

// Components
import Label from '@/components/base/Label';
import Input from '@/components/base/Input';

const InputAlbumName = () => {
    const { t } = useTranslation();
    const { albumInfo, dispatch } = useAlbumContext();

    return (
        <>
            <Label htmlFor="album-name" required>
                {t('content:modal.name')}
            </Label>
            <Input
                id="album-name"
                name="album-name"
                autoComplete="off"
                value={albumInfo?.name}
                onChange={(e) => {
                    dispatch({
                        type: UPDATE_ALBUM_NAME,
                        payload: e.target.value
                    });
                }}
                maxLength={50}
                charsCount={albumInfo?.name?.length ?? 0}
            />
        </>
    );
};

InputAlbumName.displayName = 'InputAlbumName';

export default InputAlbumName;
